import BaseDelete from 'react-fine-uploader/delete-button';

class Delete extends BaseDelete {
  componentWillMount() {
    const upload = this.props.uploader.methods.getUploads({ id: this.props.id });
    if (upload && upload.status) {
      this._onStatusChange(upload.id, null, upload.status); // eslint-disable-line no-underscore-dangle
    }
  }
}

export default Delete;
